import React, { Component, Fragment } from 'react';
import $ from 'jquery';
import 'datatables/media/css/jquery.dataTables.min.css';

class ChallengesRightContent extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.initializeDataTable();
    }

    componentDidUpdate(prevProps) {
        if (this.props.distData !== prevProps.distData) {
            this.initializeDataTable();
        }
    }

    initializeDataTable = () => {
        if ($.fn.DataTable.isDataTable('.data_table_style')) {
            $('.data_table_style').DataTable().destroy();
        }

        $('.data_table_style').DataTable({
            responsive: true,
            destroy: true,
            "oLanguage": {
                "sSearch": "",
                "sSearchPlaceholder": "Search"
            },
            "aLengthMenu": [[50, 100, 150, 200, 250, 300], [50, 100, 150, 200, 250, 300]],
            "iDisplayLength": 100,
            "order": [[1, "desc"]]
        });
    }

    render() {
        const { challengeLoading, distData } = this.props;

        return (
            <Fragment>
                {
                    challengeLoading ? (
                        <div className="loading"></div>
                    ) : (
                        <div className="tab-pane fade show active" id="tab_data" role="tabpanel" aria-labelledby="today-tab">
                            <div className="table-responsive">
                                <table className="table data_table_style w-100 subscribtion_table m-0">
                                    <thead>
                                        <tr>
                                            <th>Affiliate</th>
                                            <th>Total Sales</th>
                                        </tr>
                                    </thead>
                                   <tbody>
                                    {
                                        distData.length <= 0 ? null :
                                        distData.map((order, key) => (
                                            order.distributor_country == '223' ? (
                                            <tr key={key}>
                                                <td>{order.distributor_name}</td>
                                                <td className="text-right">{order.total_sale}</td>
                                            </tr>
                                            ) : null
                                        ))
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )
                }
            </Fragment>
        );
    }
}
export default ChallengesRightContent;